/* JS - index V11 */
(function() {
	'use strict';

	var $ = avm.require('jquery'),
		platformSwitcher = avm.require('avast.web.platformSwitcher'),
		overlayPopup = avm.require('avast.web.overlayPopup');

	// Form popup
	var $body = $('body'),
		overlayPopup = avm.require('avast.web.overlayPopup'),
		$overlayBoxTrigger = $('.overlay-box-trigger'),
		$overlayBox = $('.overlay-box');

	// Stats section animations
	var $window = $(window),
		// $document = $(document),
		$stats = $('#stats'),
		$statsP = $('#stats .stat p'),

		$countryStatsP = $('#stats .country-stat p'),
		$mainImg = $('.map #js-main-image'),
		$preloadImg = $('.map #js-preload-image'),
		imgSrc = $preloadImg.attr('src'),
		$overlayBoxClose = $('.overlay-box-close'),
		animations = {
			showImage: function () {
				$mainImg.attr('src', imgSrc);
				$mainImg.css({opacity: 0.0, visibility: "visible"}).animate({opacity: 1.0});
			},
			showHeadline: function () {
				$statsP.addClass('visible');
			},
			showCountryHeadline: function () {
				$countryStatsP.addClass('visible').animate({opacity: 1.0},1000);
			},
			statsViewPort: function () {
				if ($stats.offset().top + $stats.height()/2 < $window.scrollTop() + $window.height()) {
					this.showImage();
					this.showHeadline();
					this.showCountryHeadline();
				}
			}
		};

	$window.on('scroll', function() {
		if ($mainImg.attr('src') === '') {
			animations.statsViewPort();
		}
	});

	platformSwitcher.init();
	overlayPopup();
	$overlayBoxTrigger.on('click', function(event) {
		event.preventDefault();

		var detect = avm.require('avast.detect')(),
			os = detect.os && detect.os.name ? detect.os.name.toLowerCase() : null,
			$formTexts = $('.js-form-texts');

		if (window.location.hash === '#android') {
			window.location.hash = 'android-emailpopup';
		}
		if (window.location.hash === '#ios') {
			window.location.hash = 'ios-emailpopup';
		}
		var $tooltips = $('.tooltip-l');
		$tooltips.css('border-bottom', 0);
		$formTexts.show();
		$overlayBoxClose.show();
		$(document).on('avastform-linear-success', function() {
			$formTexts.hide();
		});

		$overlayBoxClose.on('click', function() {
			$overlayBox.removeClass('is-visible');
			$(this).hide();
			window.location.hash = os;
		});

		$(document).on('click', '.js-form-back', function() {
			$overlayBox.removeClass('is-visible');
			$body.off('mousewheel');
			$body.css('overflow', 'auto');
			window.location.hash = os;
		});

		$.ajax({
			url: 'mobile-first-email-form'
		}).done(function(data) {
			$('#mobile-first-email-form').empty().append(data);
			initAvastForm();
			$('#mobile-first-email-form input[name="os"]').val(os);
			$('#mobile-first-email-form').find('#frm-email').on('focus', function() {
				$(this).attr('placeholder', '');
			});
		});
	});

})();
